import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'loader-throbber',
  templateUrl: './loader-throbber.component.html',
  styleUrls: ['./loader-throbber.component.css']
})
export class LoaderThrobberComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }



}
